import React, { useContext } from 'react';

import { apiContainer } from '@vlabs/api-bindings';
import { StopCircleIcon, PlayCircleIcon } from '@vlabs/icons';
import { ButtonScrimGroup, Control, Tooltip } from '@vlabs/uikit';
import cn from 'classnames';
import i18n from 'i18next';

import st from './QueueCardStatus.module.sass';
import { QueueContext } from '../../queue-context/QueueContext';

const StreamStatuses = {
  0: {
    get label() {
      return i18n.t('queue:queue card.queue card status.stream status.pending.label');
    },
    icon: null,
    className: st.Pending,
  },
  1: {
    get label() {
      return i18n.t('queue:queue card.queue card status.stream status.in progress.label');
    },
    icon: <StopCircleIcon />,
    className: st.InProgress,
    get tooltipContent() {
      return i18n.t('queue:queue card.queue card status.stream status.in progress.tooltip content');
    },
  },
  2: {
    get label() {
      return i18n.t('queue:queue card.queue card status.stream status.done.label');
    },
    className: st.Error,
  },
  3: {
    get label() {
      return i18n.t('queue:queue card.queue card status.stream status.restart.label');
    },
    icon: null,
    className: st.Restart,
  },
  4: {
    get label() {
      return i18n.t('queue:queue card.queue card status.stream status.error.label');
    },
    icon: null,
    className: st.Error,
  },
  5: {
    get label() {
      return i18n.t('queue:queue card.queue card status.stream status.paused.label');
    },
    icon: <PlayCircleIcon />,
    className: st.Paused,
    get tooltipContent() {
      return i18n.t('queue:queue card.queue card status.stream status.paused.tooltip content');
    },
  },
  6: {
    get label() {
      return i18n.t('queue:queue card.queue card status.stream status.unknown.label');
    },
    className: st.Unknown,
  },
  7: {
    get label() {
      return i18n.t('queue:queue card.queue card status.stream status.handler lost.label');
    },
    className: st.Error,
  },
};

export function QueueCardStatus({ status, streamId }) {
  const { fetchStreams } = useContext(QueueContext);

  const handleClickStatus = () => {
    if (status === 1) {
      apiContainer.lunaClient.streams.patch(streamId, 'stop');
      fetchStreams();
    }
    if (status === 5) {
      apiContainer.lunaClient.streams.patch(streamId, 'resume');
      fetchStreams();
    }
  };

  if (!StreamStatuses[status]) return null;

  return (
    <div
      className={cn(
        st.QueueStatusButton,
        StreamStatuses[status]?.className,
        {
          [st.WithAction]: StreamStatuses[status]?.icon,
        },
      )}
    >
      <div>{StreamStatuses[status]?.label}</div>
      {!!StreamStatuses[status]?.icon && (
      <Tooltip
        position="bottom"
        tooltipContent={StreamStatuses[status].tooltipContent || null}
      >
        <ButtonScrimGroup size="small">
          <Control.IconButton
            data-testid="QueueCardStatus_statusButton"
            icon={StreamStatuses[status].icon}
            kind={status === 1 ? 'negative' : 'positive'}
            onClick={handleClickStatus}
            size="small"
          />
        </ButtonScrimGroup>
      </Tooltip>
      )}
    </div>
  );
}
